export default __webpack_public_path__ + "static/media/md.e3ddf4b1.png";